import { Report } from 'store/store';

export const addScormResponseAction = (scormAction: Report) => {
  return {
    type: 'ADD_SCORM_RESPONSE',
    data: scormAction,
  };
};
